import React from "react";
import DataGrid from "features/shared/components/dataGrid/DataGrid";
import { DataGridId } from "features/shared/components/dataGrid/DataGridId";
import DepositAgreementHeader from "../components/DepositAgreementHeader";
import DepositAgreementCard from "../components/DepositAgreementCard";
import DepositAgreementNoContentAlert from "../components/DepositAgreementNoContentAlert";
import { DepositAgreementDTO } from "../dtos/DepositAgreementDTO";
import { Customer_DepositAgreement } from "data/endpoints";
import DataGridHeader from "features/shared/components/dataGrid/DataGridHeader";

type DepositAgreementItem = NonNullable<DepositAgreementDTO["result"]>[number];

const DepositAgreementSection = () => {

  return (
    <DataGrid<DepositAgreementItem>
      gridId={DataGridId.depositAgreementGrid}
      url={Customer_DepositAgreement}
      filterJson={"[]"}
      renderCustomGridHeader={(count, filterActive) => (
        <DataGridHeader
          count={count}
          filterActive={!!filterActive}
        />
      )}
      renderHeader={() => <DepositAgreementHeader />}
      renderItem={(item) => <DepositAgreementCard depositAgreement={item} />}
      renderNoContent={() => <DepositAgreementNoContentAlert />}
      itemAsCard={false}
    />
  );
};

export default DepositAgreementSection;
